import { Icon, Stack, Text, Tooltip } from '@cheqroom/ui';
import { FC } from 'react';
import tw, { styled } from 'twin.macro';

import { Location } from '../../../../../../@types/python.d';
import { createLocationPathTooltip } from './LocationPathTooltip';
import { getIcon } from './utils';

export type SublocationData = Location[];

const SublocationContainer = styled.div`
	${tw`relative overflow-hidden max-w-full`}

	/* Fade on the left side */
	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 20px;
		background: linear-gradient(to right, white, transparent);
		pointer-events: none;
		z-index: 1;
	}
`;

export const Sublocation: FC<{ data: SublocationData }> = ({ data: allLocations }) => {
	// Root location is the first element, sublocations are everything after
	const sublocations = allLocations.slice(1);

	// Tooltip shows full path including root
	const tooltipContent = createLocationPathTooltip(allLocations);

	return (
		<Tooltip content={tooltipContent} hasArrow enabled={!!tooltipContent}>
			<SublocationContainer>
				<Stack spacing="extraTight" align="center" tw="justify-end">
					{sublocations.flatMap((loc, index) => {
						const IconComponent = getIcon(loc.icon, false);

						const elements = [
							<Stack key={loc._id} spacing="extraTight" align="center">
								{IconComponent && <Icon source={IconComponent} size="small" tw="text-gray-400" />}
								<Text tw="text-xs text-gray-500 whitespace-nowrap">{loc.name}</Text>
							</Stack>,
						];

						if (index < sublocations.length - 1) {
							elements.push(
								<Text key={`sep-${loc._id}`} tw="text-xs text-gray-500">
									/
								</Text>
							);
						}

						return elements;
					})}
				</Stack>
			</SublocationContainer>
		</Tooltip>
	);
};
